import { Paragraph, SectionType, HeadingLevel, ISectionOptions } from 'docx'
import highlights from '../common/highlights'
import { Resume } from '@/types/resume/v1'

const additional = ({ additional }: Resume.Schema): ISectionOptions => {
  const bullets = additional.map(i => i.description)
  return {
    properties: {
      type: SectionType.CONTINUOUS,
    },
    children: [
      new Paragraph({
        text: '\n',
      }),
      new Paragraph({
        text: 'Additional',
        heading: HeadingLevel.HEADING_2,
      }),
      ...highlights(bullets),
    ],
  }
}

export default additional
